var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline" } },
    [
      !!_vm.attachmentList && _vm.attachmentList.length > 0
        ? _c(
            "div",
            { staticClass: "_attachment_list" },
            _vm._l(_vm.attachmentList, function(each, i) {
              return _c("div", { key: i, staticClass: "_attachment_0" }, [
                _vm.isImage(each)
                  ? _c("img", {
                      staticClass: "upload_img",
                      attrs: { src: each.filePath }
                    })
                  : _c(
                      "a",
                      { attrs: { target: "_blank", href: each.filePath } },
                      [_vm._v(_vm._s(each.fileName))]
                    )
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-uploader",
        {
          attrs: {
            "result-type": "file",
            accept: "*",
            "after-read": _vm.uploaderAfterRead
          }
        },
        [
          _c(
            "van-button",
            { staticStyle: { width: "45vw" }, attrs: { size: "small" } },
            [_vm._v("上传图片或视频")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41a46d17", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41a46d17","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/MobileTicketUpload.vue
// module id = 606
// module chunks = 75